export default function isSameElement(parent, element) {
  if (element === parent) {
    return true;
  }
  let parentNode = element.parentNode;
  while (parentNode) {
    if (parentNode === parent) {
      return true;
    }
    parentNode = parentNode.parentNode;
  }
  return false;
}
